<template>
  <div class="spareRequirements lianchulianbei wr-sjz">
    <div class="container">
      <Breadcrumb :pageTitle="pageTitle" />
      <Step :steps="steps" :activeIndex="activeIndex" />
      <div class="body-info">
        <el-form
          :model="input"
          :rules="rules"
          ref="dataForm"
          label-width="160px"
        >
          <h2 class="title">{{$t('account.basicInfo')}}</h2>
          <!-- 备件需求单号 开始 -->
          <el-form-item :label="`${$t('product.requisitionNo')}：`" v-if="detail" prop="demandCode">
            {{ detail.demandCode }}
          </el-form-item>
          <!-- 备件需求单号 开始 -->
          <el-form-item :label="`${$t('product.estimatedTime')}：`" prop="wishEndDate">
            <el-date-picker
              v-model="input.wishEndDate"
              type="date"
              size="small"
              :placeholder="$t('message.select')"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions1"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <!-- 备料期望完成日期 结束 -->
          <!-- 预计收件地址 开始 -->
          <el-form-item
            :label="`${$t('stockNeed.shippingAddress')}：`"
            prop="userAddressId"
            style="width: 100%;"
          >
            <AddressList
              v-if="detail"
              @chooseAddress="chooseAddress"
              :addressId="input.userAddressId"
              :isEdit="true"
            />
          </el-form-item>
          <!-- 预计收件地址 结束 -->
          <!-- 备件需求协议 开始 -->
          <el-form-item :label="`${$t('stockNeed.spareNeeAgreement')}：`" prop="ossRelation">
            <UploadFile
              ref="uploadFile"
              :fileList="fileList"
              :limit="10"
              :buttonText="$t('stockNeed.uploadFile')"
              :beforeUpload="beforeUpload"
              :tip="$t('stockNeed.uploadFileNote')"
              @onSuccess="successFile"
            />
          </el-form-item>
          <!-- 备件需求协议 结束 -->
          <!-- 备注 开始 -->
          <el-form-item :label="`${$t('stockNeed.comment')}：`" prop="remarks">
            <label>
              <el-input
                v-model="input.remarks"
                type="textarea"
                :placeholder="$t('stockNeed.enterRemark')"
                style="width:900px !important;"
                :rows="3"
                maxlength="200"
                show-word-limit
              ></el-input>
            </label>
          </el-form-item>
          <!-- 备注 结束 -->
          <h2 class="title">{{$t('stockNeed.spareNeedInformation')}}</h2>
          <el-form-item :label="`${$t('stockNeed.spareInformation')}：`" >
            <el-button
              type="primary"
              size="small"
              class="btn"
              @click="importInfo"
              >{{$t('stockNeed.uploadEXCEL')}}</el-button
            >
            <el-button type="text" class="downloadTem" @click="downloadTemplate"
              >{{$t('stockNeed.downloadTemplate')}}</el-button
            >
            <el-upload
              v-show="false"
              ref="fielUplod"
              :on-success="fileSuccess"
              :on-error="fileError"
              accept="csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              :headers="headerMsg"
              :action="actionUrl1"
            >
              <el-button type="primary">{{$t('oss.upload')}}</el-button>
            </el-upload>
          </el-form-item>
          <!-- 表格 开始 -->
          <el-form-item class="no-margin" prop="demandDetailList">
            <el-table
              :data="input.demandDetailList"
              border
              style="width: 1150px;"
            >
              <el-table-column
                type="index"
                width="50"
                :label="$t('product.id')"
              ></el-table-column>
              <el-table-column
                prop="oldGoodsCode"
                header-align="center"
                align="center"
                :label="$t('product.codes')"
                width="160"
                :render-header="renderHeader"
              >
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`demandDetailList.${scope.$index}.oldGoodsCode`"
                    :rules="tableRules.oldGoodsCode"
                  >
                    <el-autocomplete
                      :minlength="2"
                      v-model="scope.row.oldGoodsCode"
                      :fetch-suggestions="querySearchAsync"
                      :placeholder="$t('evaluate.placeholder')"
                      @input="(e) => handleChange(e, scope, scope.$index)"
                      @select="handleSelect($event, scope.$index)"
                      style="width:auto !important"
                      popper-class="my-kqoption"
                      :trigger-on-focus="false"
                      :maxlength="20"
                    ></el-autocomplete>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                prop="oldGoodsName"
                header-align="center"
                align="center"
                :label="$t('model.name')"
                :render-header="renderHeader"
                width="160"
              >
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`demandDetailList.${scope.$index}.oldGoodsName`"
                    :rules="tableRules.oldGoodsName"
                  >
                    <el-input
                      :placeholder="$t('stockNeed.limitFifty')"
                      maxlength="50"
                      v-model="scope.row.oldGoodsName"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                prop="oldSpecification"
                header-align="center"
                align="center"
                :label="$t('common.specification')"
                :render-header="renderHeader"
                width="200"
              >
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`demandDetailList.${scope.$index}.oldSpecification`"
                    :rules="tableRules.oldSpecification"
                  >
                    <el-input
                      :placeholder="$t('stockNeed.limitTwoHundred')"
                      maxlength="200"
                      v-model="scope.row.oldSpecification"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                prop="oldModel"
                header-align="center"
                align="center"
                :label="$t('common.model')"
                :render-header="renderHeader"
                width="160"
              >
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`demandDetailList.${scope.$index}.oldModel`"
                    :rules="tableRules.oldModel"
                  >
                    <el-input
                      :placeholder="$t('stockNeed.limitTwoHundred')"
                      maxlength="200"
                      v-model="scope.row.oldModel"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                prop="oldBrand"
                header-align="center"
                align="center"
                :label="$t('common.brand')"
                width="160"
              >
                <template slot-scope="scope">
                  <el-input
                    :placeholder="$t('stockNeed.limitTwoHundred')"
                    maxlength="200"
                    v-model="scope.row.oldBrand"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="sellingUnit"
                header-align="center"
                align="center"
                :label="$t('common.unit')"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="safetyStockQuantityBef"
                header-align="center"
                align="right"
                :label="$t('stockNeed.appliedAmount')"
                width="160"
              >
                <template slot-scope="scope">
                  <span class="addLine">{{
                    scope.row.safetyStockQuantityBef
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="lclbCommodityType"
                header-align="center"
                align="center"
                :label="$t('stockNeed.inventoryType')"
                fixed="right"
                width="120"
                :render-header="renderHeader"
              >
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`demandDetailList.${scope.$index}.lclbCommodityType`"
                    :rules="tableRules.lclbCommodityType"
                  >
                    <el-select
                      v-model="scope.row.lclbCommodityType"
                      filterable
                      clearable
                      :placeholder="$t('message.select')"
                    >
                      <el-option
                        v-for="(itme, index) in lclbCommodityType"
                        :label="itme.value"
                        :value="itme.code"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                prop="safetyStockQuantity"
                header-align="center"
                align="right"
                :label="$t('stockNeed.amount')"
                :render-header="renderHeaderNew"
                width="170"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      `demandDetailList.${scope.$index}.safetyStockQuantity`
                    "
                    :rules="tableRules.safetyStockQuantity"
                  >
                    <el-input-number
                      controls-position="right"
                      style="width:150px"
                      v-model="scope.row.safetyStockQuantity"
                      :precision="0"
                      :step="scope.row.physicalUnitAmount || 1"
                      :min="1"
                      :max="9999999"
                    ></el-input-number>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('handle')"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="deleteHandle(scope.row, scope.$index)"
                    >{{$t('delete')}}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div @click="addNew" class="add-row">
              （{{$t('stockNeed.addLine')}}）
            </div>
          </el-form-item>
          <!-- 表格 结束 -->
          <!-- 表格附件 开始 -->
          <el-form-item :label="`${$t('stockNeed.attachment')}：`" prop="xyOssRelations">
            <UploadFile
              ref="uploadFileF"
              :limit="10"
              :buttonText="$t('stockNeed.uploadFile')"
              :fileList="fileListF"
              :beforeUpload="beforeUpload"
              :tip="$t('stockNeed.uploadFileNote')"
              @onSuccess="successFileF"
            />
          </el-form-item>
          <!-- 表格附件 结束 -->
          <!-- 操作按钮区域 开始 -->
          <div
            class="row"
            style="display:flex;justify-content: center;margin-top:20px"
          >
            <el-button
              size="medium"
              class="default-btn"
              :loading="subLoading"
              @click="goBack"
            >
              {{$t('common.back')}}
            </el-button>
            <el-button
              type="primary"
              size="medium"
              :loading="subLoading"
              @click="handleSubmit"
            >
              {{$t('confirm')}}
            </el-button>
          </div>
          <!-- 操作按钮区域 结束 -->
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/index'
import AddressList from '@/components/address/list'
import UploadFile from '@/components/upload/file'
import Step from '../components/Step.vue'
import { getAccessToken } from '@/utils/userInfo'
import qs from 'qs'

export default {
  components: {
    Breadcrumb,
    Step,
    AddressList,
    UploadFile
  },
  data () {
    return {
      changeAble: false,
      lclbCommodityType: [...(window.SITE_CONFIG.dictList.LCLB_COMMODITY_TYPE || '')],
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.spareRequisition'),
          url: '/spareRequirementsList'
        },
        {
          label: this.$t('route.requisitionNeedUpdate')
        }
      ],
      rules: {
        // wishEndDate: [
        //   {
        //     required: true,
        //     message: '请选择备料期望完成日期',
        //     trigger: 'change'
        //   }
        // ],
        userAddressId: [
          { required: true, message: this.$t('message.chooseAddress'), trigger: 'change' }
        ],
        demandDetailList: [
          {
            type: 'array',
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ]
      },
      // 表格字段校验
      tableRules: {
        // 物品编码
        oldGoodsCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 物品名称
        oldGoodsName: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 规格
        oldSpecification: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 型号
        oldModel: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 备件数量
        safetyStockQuantity: [
          { required: true, message: this.$t('validate.required') },
          { type: 'number', message: '备件数量必须大于0', min: 1 },
          { type: 'number', message: '备件数量必须小于7位数', max: 9999999 }
        ],
        lclbCommodityType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      },
      activeIndex: 0,
      steps: [
        {
          ind: 1,
          key: '',
          name: this.$t('stockNeed.step1')
        },
        {
          ind: 2,
          key: '',
          name: this.$t('stockNeed.step2')
        },
        {
          ind: 3,
          key: '',
          name: this.$t('stockNeed.step3')
        },
        {
          ind: 4,
          key: '',
          name: this.$t('stockNeed.step4')
        },
        {
          ind: 5,
          key: '',
          name: this.$t('stockNeed.step5')
        }
      ],
      input: {
        demandId: '', // 主键
        wishEndDate: '', // 期望完成备货时间
        userAddressId: '', // 收货地址
        ossRelation: [], // 备件需求协议[]
        remarks: '', // 备注
        demandDetailList: [], // 商品信息
        xyOssRelations: [] // 附件[]
      },
      headerMsg: {
        token: getAccessToken()
      },
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() < Date.now() + 3600 * 1000 * 24 * 6
        }
      },
      subLoading: false, // 按钮加载中
      actionUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      actionUrl1:
        window.SITE_CONFIG['apiURL'] +
        '/front/order/lclb/demand/importSpareParts',
      fileList: [], // 用于附件回显
      fileListF: [],
      companyId: localStorage.getItem('defaultCompanyId') || null,
      detail: null
    }
  },
  created () {
    // 获取详情
    this.getDeatail()
  },
  methods: {
    focusAmount () {
      this.changeAble = true
    },
    // 修改步长
    changeAmount (currentValue, oldValue, val, index) {
      // if (this.changeAble) return false
      // let value = this.input.demandDetailList[index]
      // if (value.physicalUnitAmount) {
      //   if (currentValue > oldValue) {
      //     let num = oldValue % value.physicalUnitAmount
      //     if (num !== 0) {
      //       this.input.demandDetailList[index].safetyStockQuantity = this.input.demandDetailList[index].safetyStockQuantity - num
      //     }
      //   }
      //   if (currentValue < oldValue) {
      //     let num = oldValue % value.physicalUnitAmount
      //     if (num !== 0) {
      //       this.input.demandDetailList[index].safetyStockQuantity = this.input.demandDetailList[index].safetyStockQuantity + (value.physicalUnitAmount - num)
      //     }
      //   }
      // }
    },
    // 获取详细信息
    getDeatail () {
      this.$http
        .get(`/front/order/lclb/demand/info/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            const json = res.data
            this.detail = json
            // 回显数据
            const keys = Object.keys(this.input)
            keys.forEach((key) => {
              this.input[key] = json[key]
            })
            // 设置附件回显 开始
            // 备件需求协议
            if (json.ossFile) {
              const fileList = []
              this.input.ossRelation = json.ossFile.map((item) => {
                fileList.push({
                  name: item.fileName,
                  url: item.url,
                  aliOssId: item.aliOssId
                })
                return { aliOssId: item.aliOssId }
              })
              this.fileList = fileList
            }
            // 附件
            if (json.xyOssFiles) {
              const fileListF = []
              this.input.xyOssRelations = json.xyOssFiles.map((item) => {
                fileListF.push({
                  name: item.fileName,
                  url: item.url,
                  aliOssId: item.aliOssId
                })
                return { aliOssId: item.aliOssId }
              })
              this.fileListF = fileListF
            }
            // 设置附件回显 结束
          }
        })
    },
    // 切换地址
    chooseAddress (userAddressId) {
      this.input.userAddressId = userAddressId
      this.$refs.dataForm.validateField('userAddressId')
    },
    // table 必填项标题加*号
    renderHeader (cerateElement, { column }) {
      return cerateElement('div', [
        cerateElement('span', column.label),
        cerateElement('span', {
          domProps: {
            innerHTML: '*'
          },
          style: {
            color: 'red',
            fontSize: '16px',
            marginLeft: '5px'
          }
        })
      ])
    },
    renderHeaderNew (cerateElement, { column }) {
      return cerateElement('div', [
        cerateElement('span', column.label),
        cerateElement('span', {
          domProps: {
            innerHTML: '*'
          },
          style: {
            color: 'red',
            fontSize: '16px',
            marginLeft: '5px'
          }
        }),
        cerateElement(
          'el-tooltip',
          {
            props: {
              effect: 'dark',
              content: this.$t('message.finalQuantity'),
              placement: 'top'
            }
          },
          [
            cerateElement('i', {
              class: 'el-icon-info',
              style: 'color: #e6a23cmargin-left:2px'
            })
          ]
        )
      ])
    },
    beforeUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error(this.$t('message.uploadLimit', { 'limit': 100 }))
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (!regx.test(newName)) {
        this.$message.warning(
          this.$t('message.uploadError')
        )
        return false
      }
      return true
    },
    // 手工增行
    addNew () {
      const list = this.input.demandDetailList
      // 判断是不是都填写了

      if (list.length > 0) {
        const obj = list[list.length - 1]
        const {
          oldGoodsCode,
          oldGoodsName,
          oldSpecification,
          oldModel,
          safetyStockQuantity
        } = obj
        if (
          !oldGoodsCode ||
          !oldGoodsName ||
          !oldSpecification ||
          !oldModel ||
          !safetyStockQuantity
        ) {
          this.$message.error(this.$t('message.noMultipleEmpty'))
          return
        }
      }

      this.input.demandDetailList.push({
        spuId: '',
        skuId: '',
        oldGoodsCode: '',
        oldGoodsName: '',
        oldSpecification: '',
        oldModel: '',
        oldRemark: '',
        safetyStockQuantity: '',
        oldBrand: '',
        sellingUnit: '',
        physicalUnitAmount: ''
      })
    },
    // 删除一行
    deleteHandle (row, index) {
      this.input.demandDetailList.splice(index, 1)
    },
    handleChange (ind, a, index) {
      this.input.demandDetailList[index].spuId = ''
      this.input.demandDetailList[index].skuId = ''
      this.input.demandDetailList[index].oldGoodsName = ''
      this.input.demandDetailList[index].oldModel = ''
      this.input.demandDetailList[index].oldRemark = ''
      this.input.demandDetailList[index].oldSpecification = ''
      this.input.demandDetailList[index].oldBrand = ''
      this.input.demandDetailList[index].sellingUnit = ''
      this.input.demandDetailList[index].safetyStockQuantityBef = ''
      this.input.demandDetailList[index].physicalUnitAmount = ''
      this.input.demandDetailList[index].safetyStockQuantity = 1
    },
    querySearchAsync (queryString, cb) {
      const array = []
      if (queryString && queryString.length > 1) {
        let params = {
          likeFlag: '1',
          oldGoodsCode: queryString,
          companyId: this.companyId
        }
        this.$http
          .post(`/front/order/lclb/demand/getStockBefByOrdinary`, params)
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data && res.data.length > 0) {
                res.data.forEach((item) => {
                  item.value = item.codeSpeciModel
                })
                cb(res.data)
              } else {
                cb(array)
              }
            } else {
              cb(array)
            }
          })
      } else {
        cb(array)
      }
    },
    handleSelect (item, index) {
      this.input.demandDetailList[index].spuId = item.spuId
      this.input.demandDetailList[index].skuId = item.skuId
      this.input.demandDetailList[index].oldGoodsCode = item.oldGoodsCode
      this.input.demandDetailList[index].oldGoodsName = item.oldGoodsName
      this.input.demandDetailList[index].oldModel = item.oldModel
      this.input.demandDetailList[index].oldRemark = item.oldRemark
      this.input.demandDetailList[index].oldSpecification =
        item.oldSpecification
      this.input.demandDetailList[index].oldBrand = item.oldBrand
      this.input.demandDetailList[index].sellingUnit = item.sellingUnit
      this.input.demandDetailList[index].physicalUnitAmount = item.physicalUnitAmount
      this.input.demandDetailList[index].safetyStockQuantity =
        item.safetyStockQuantity
      this.input.demandDetailList[index].safetyStockQuantityBef =
        item.safetyStockQuantityBef
    },
    // 备件信息上传
    importInfo () {
      // this.$refs.inputer.click()
      this.$refs.fielUplod.$el.childNodes[0].childNodes[1].click()
    },
    // 导入成功
    fileSuccess (response, file, fileList) {
      if (response.data && response.code === 0) {
        this.$message.success(response.message)
        const totalList = [...this.input.demandDetailList, ...response.data]
        this.input.demandDetailList = totalList
      } else {
        this.$alert(response.message, '批量导入失败原由', {
          confirmButtonText: this.$t('confirm'),
          type: 'error'
        }).catch(() => {})
      }
    },
    // 导入失败
    fileError (file, fileList) {
      this.$message.error('导入失败，请重新上传')
    },
    // 模板下载
    downloadTemplate () {
      const json = {
        token: getAccessToken()
      }
      window.location.href = `${
        window.SITE_CONFIG['apiURL']
      }/front/consumer/templatedownload/sparePartsDemandImport?${qs.stringify(
        json
      )}`
    },
    // 返回列表
    goBack () {
      if (this.$route.query.from === 'sparePartsLibraryGoodDetail') {
        this.$router.back()
        return
      }
      this.$router.push({ name: 'spareRequirementsList' })
    },
    // 执行提交
    doSubmit (obj) {
      this.subLoading = true
      this.$http
        .post('/front/order/lclb/demand/updateByOrdinary', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            if (res.data && res.data.indexOf('物品后续的可领用量') > 0) {
              this.$alert(res.data, '备件数量提示', {
                confirmButtonText: '我知道了',
                type: 'warning',
                showClose: false
              })
                .then((res) => {
                  this.$message.success('编辑成功')
                  this.goBack()
                })
                .catch(() => {})
              return
            }
            this.$message.success('编辑成功')
            this.goBack()
          }
          this.subLoading = false
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 确认
    handleSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          // 处理数据
          const obj = {
            ...this.input,
            companyId: this.companyId
          }
          this.doSubmit(obj)
        } else {
          this.$nextTick(() => {
            const isError = document.getElementsByClassName('is-error')
            isError[0].querySelector('input').focus()
          })
          this.$message.warning(this.$t('message.requiredError'))
        }
      })
    },
    // 上传成功
    successFile (response) {
      this.input.ossRelation = response.map((item) => {
        return { aliOssId: item }
      })
    },
    // 附件上传成功
    successFileF (response) {
      this.input.xyOssRelations = response.map((item) => {
        return { aliOssId: item }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  margin: 0 0 20px 0;
  font-size: 20px;
  color: #262626;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-word;
}

.add-row {
  margin: 8px 6px 0 6px;
  text-align: center;
  color: #a1b6c6;
  cursor: pointer;
  user-select: none;
  border: 1px dashed transparent;
  background: linear-gradient(white, white) padding-box,
    repeating-linear-gradient(
      -45deg,
      #a1b6c6 0,
      #a1b6c6 0.5em,
      white 0,
      white 0.75em
    );
}
.no-margin {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
